import React, { useEffect, useState } from "react";
import { Flex, Layout, Menu,ConfigProvider } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { colors } from "../../../constants/colors";
import styles from "./Sidebar.module.scss";
import { userRoles } from "../../../constants";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { appConfig } from "../../../constants/config/appConfig";
import { useAdminSidebarUtils } from "../../../utils/sidebarUtils/provider/admin/useAdminSidebarUtils";
import { useStaffSidebarUtils } from "../../../utils/sidebarUtils/provider/staff/useStaffSidebarUtils";
import { useSuperAdminSidebarUtils } from "../../../utils/sidebarUtils/super-admin/useSuperAdminSidebarUtils";
import { useDispatch, useSelector } from "react-redux";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import Actions from "../../../redux/actions";
import { useTranslation } from "react-i18next";
import { TinyColor } from '@ctrl/tinycolor';
const Sidebar = () => {
  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  /* location dependencies */
  const location = useLocation();
  /* location dependencies */

  const { t } = useTranslation();

  const dispatch = useDispatch();

  /* local storage dependencies */
  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);
  /* local storage dependencies */

  const [isMenuItemHovered, setIsMenuItemHovered] = useState("");

  /* sidebar dependencies */
  const renderRoleBasedSidebarUtil = {
    [userRoles.SUPER_ADMIN]: useSuperAdminSidebarUtils(t),
    [userRoles.SERVICE_PROVIDER_ADMIN]: useAdminSidebarUtils(t),
    [userRoles.SERVICE_PROVIDER_ADMIN_ROLES.REGULAR_STAFF]: useStaffSidebarUtils(userSession, t),
    [userRoles.SERVICE_PROVIDER_ADMIN_ROLES.MEDICAL_STAFF]: useStaffSidebarUtils(userSession, t),
    [userRoles.SERVICE_PROVIDER_ADMIN_ROLES.DOCTOR]:useStaffSidebarUtils(userSession),
    [userRoles.SUPER_ADMIN_ROLES.ACCOUNTANT]: useStaffSidebarUtils(userSession, t),
    [userRoles.SUPER_ADMIN_ROLES.CUSTOMER_SUPPORT]: useStaffSidebarUtils(userSession, t),
  };

  const menuGroup = userSession && userSession?.userRole !== "customer" ? renderRoleBasedSidebarUtil[userSession?.userRole] : [];
  /* sidebar dependencies */

  return (
    <>
      <Layout.Sider width={250} theme="light"  className={styles.sidebarWrapper}>
      <ConfigProvider
      theme={{
        components: {
          Menu: {
          itemBorderRadius:5
          },
        },
      }}
    >
       <Menu
          mode="inline"
          selectedKeys={menuGroup
            ?.filter((element) => location.pathname.includes(element.path))
            .map((_element) => _element.path)}
          onClick={({ key }) => {
            if (key !== baseRouteMaker(routes.CHAT)) {
              dispatch(
                Actions.createAction(
                  Actions.GET_SERVICE_PROVIDER_USER_CHAT_DETAILS_BY_ID,
                  { serviceProviderUserChatDetailsById: {} }
                )
              );
              dispatch(
                Actions.createAction(
                  Actions.GET_SERVICE_PROVIDER_USER_CHAT_MESSAGES,
                  { serviceProviderUserChatMessages: {} }
                )
              );
            }
            navigate(key);
          }}
          className={styles.sideBarContainer}
          
        >
          {menuGroup?.map((element) => {
            return (
              <Menu.Item
                key={element?.path}
                onMouseEnter={() => setIsMenuItemHovered(element?.path)}
                onMouseLeave={() => setIsMenuItemHovered("")}
                style={{
                   background: location.pathname.includes(element?.path) ||  isMenuItemHovered === element?.path ?'linear-gradient(135deg, #06EC80, #097AF2)':''
                }}
              >
                <Flex align="center" gap="0.6rem">
                  <element.icon
                    fillColor={
                      location.pathname.includes(element?.path) ||
                      isMenuItemHovered === element?.path
                        ? colors.white
                        : colors.gunMetalGray
                    }
                  />
                  <span
                    style={{
                      color:
                        location.pathname.includes(element?.path) ||
                        isMenuItemHovered === element?.path
                          ? colors.white
                          : colors.gunMetalGray,
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      width: "150px",
                      overflow: "hidden",
                    }}
                  >
                    {element?.label}
                  </span>
                </Flex>
              </Menu.Item>
            );
          })}
        </Menu>
    </ConfigProvider>
       
      </Layout.Sider>
    </>
  );
};

export default Sidebar;
